module.exports = __webpack_public_path__ + "img/fighters_hall_small.870c3ecf.png";